import { AntButton } from './styles'

export default AntButton
